export const dutchHeaderTranslations: { [key: string]: string } = {
  Titel: "Title",
  Gebruikersnaam: "Username",
  Wachtwoord: "Password",
  Gewijzigd: "Modified",
  Gemaakt: "Created",
  "Verloopt op": "Expire on",
  Beschrijving: "Description",
  "Gewijzigd door": "Modified by",
};
